import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { languageCodeZodSchema } from "@@/shared/translations/language-code";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const translateCommandZodObject = z.object({
    _id: z.string(),
    _type: z.literal("TRANSLATE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    text: z.string().min(1),
    from: languageCodeZodSchema,
    to: languageCodeZodSchema,
    /** Provider id is required if the request is for a provider dashboard */
    providerId: providerIdZodSchema.optional(),
});

type TranslateCommand = z.infer<typeof translateCommandZodObject>;

const translateCommandFactoryParamsZodObject = translateCommandZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});

type TranslateCommandFactoryParams = z.infer<
    typeof translateCommandFactoryParamsZodObject
>;
const translateCommandFactory = (
    params: TranslateCommandFactoryParams,
): TranslateCommand => {
    return {
        _id: generateId({ prefix: "translate_command__" }),
        _type: "TRANSLATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
        ...params,
    };
};

export {
    translateCommandFactory,
    translateCommandFactoryParamsZodObject,
    translateCommandZodObject,
};
export type { TranslateCommand, TranslateCommandFactoryParams };
